import type { CSSProperties, ReactNode } from "react";

type RuntimeWidthAttributes = { style: CSSProperties };

type RuntimeWidthProps = {
  width: CSSProperties["width"];
  children: (attributes: RuntimeWidthAttributes) => ReactNode;
};

/**
 * Applies widths calculated by third-party or live layout APIs. The render prop
 * keeps the runtime style narrowly typed instead of exposing a general style escape.
 */
export function RuntimeWidth({ width, children }: RuntimeWidthProps): ReactNode {
  return children({ style: { width } });
}
